module.exports = __webpack_public_path__ + "img/lr-cb9-r1.6f6511ee.gif";